import { designToken, quickProperty } from '../component-tokens';
import { inputFieldBase, smallInputFieldBase } from './common';
export const searchFieldTokens = {
    name: 'search-field',
    tag: 'chameleon-search-field',
    reactImports: 'SearchField',
    attributes: Object.assign(Object.assign({}, inputFieldBase), { height: quickProperty('2rem'), width: quickProperty('100%'), position: quickProperty('relative'), gap: designToken('spacing-01'), padding: quickProperty('0 0.75rem'), border: quickProperty('1px solid transparent'), 'background-color': designToken('surface-color-secondary'), display: quickProperty('flex'), 'align-items': quickProperty('center') }),
    sizes: [
        {
            name: 'small',
            attributes: Object.assign(Object.assign({}, smallInputFieldBase), { height: quickProperty('1.5rem') }),
            children: [
                {
                    name: 'placeholder',
                    attributes: {
                        font: designToken('body-small'),
                    },
                },
            ],
        },
        {
            name: 'large',
            attributes: {
                height: quickProperty('2.5rem'),
            },
        },
        {
            name: 'xlarge',
            attributes: {
                height: quickProperty('3rem'),
            },
        },
    ],
    states: [
        {
            name: 'hover',
            attributes: {
                'background-color': designToken('surface-color-secondary'),
                'border-color': designToken('border-color-default'),
            },
        },
        {
            name: 'focus',
            attributes: {
                'background-color': designToken('surface-color-default'),
                'border-color': designToken('focus-border-color-default'),
                'box-shadow': quickProperty('0 0 0 1px var(--goto-focus-color-highlight-default)'),
            },
        },
        {
            name: 'disabled',
            attributes: {},
            children: [
                {
                    name: 'placeholder',
                    attributes: {
                        color: designToken('type-color-disabled'),
                    },
                },
                {
                    name: 'icon',
                    attributes: {
                        color: designToken('icon-color-disabled'),
                    },
                },
            ],
        },
    ],
};
